import * as React from "react";
import { IWidgetContext, IBaseConfig } from "../Models";

/**
 * React Widget context provider
 * allows to propagate immutable values
 * through the widget componets
 * @export
 * @const WidgetContext
 * @extends {React.Context}
 */
export const WidgetContext = React.createContext<
  IWidgetContext<IBaseConfig | any>
>({} as IWidgetContext<IBaseConfig>);
export const ContextProvider: React.ProviderExoticComponent<
  React.ProviderProps<IWidgetContext<IBaseConfig | any>>
> = WidgetContext.Provider;
export const Context: React.ExoticComponent<
  React.ConsumerProps<IWidgetContext<IBaseConfig | any>>
> = WidgetContext.Consumer;
export function withContext<T>(Component: any): React.FC<T> {
  return function (props: T) {
    return (
      <Context>{(context) => <Component {...props} {...context} />}</Context>
    );
  };
}
